import React, { useRef } from "react";
import { useRecoilState } from "recoil";
import { TextField } from "@mui/material";
import {
  NewReqBillingRadioTreatmentNotesAccordionWrapper,
  NewReqBillingRadioTreatmentNotesWrapper,
  NewReqTreatmentNotesInfoIcon,
  NewReqTreatmentNotesTooltip,
  NewReqTooltipContent,
  NewReqTreatmentNotesMessage,
} from "./NewRequisition.styles";
import { currentNewRequisitionEdit } from "../../recoil/atoms";
import { getNewReqTreatmentScreenNotes } from "./helpers";
import { UserReportGenerateNotesModalNPIMessage } from "../UserReport/UserReport.styles";
import { Button } from "../shared/Button/Button";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";
import { Accordions } from "../shared/Accordion/Accordions";

const getEditButtonText = (mobile: boolean, notesEditable: boolean) => {
  if (mobile) {
    return notesEditable ? "REVERT" : "CUSTOMIZE";
  }
  return notesEditable ? "REVERT TO DEFAULT" : "CUSTOMIZE NOTES";
};

const NewReqBillTreatmentNotes: React.FC = () => {
  const { physicalDeviceType } = useDeviceHook();
  const [newRequisition, setNewRequisition] = useRecoilState(
    currentNewRequisitionEdit,
  );
  const { requisitionForm } = newRequisition;

  const notesFieldReference = useRef<HTMLInputElement | null>(null);

  return (
    <>
      <NewReqBillingRadioTreatmentNotesAccordionWrapper
        preflight={newRequisition.preflight}
      >
        <Accordions
          data={[
            {
              title: "Treatment Notes",
              titleAccessory: (
                <NewReqTreatmentNotesTooltip
                  title={
                    <NewReqTooltipContent>
                      Treatment notes with referral details (requested by some
                      insurance plans for claim approval)
                    </NewReqTooltipContent>
                  }
                >
                  <NewReqTreatmentNotesInfoIcon />
                </NewReqTreatmentNotesTooltip>
              ),
              content: (
                <NewReqBillingRadioTreatmentNotesWrapper
                  deviceType={physicalDeviceType}
                >
                  {newRequisition.preflight && (
                    <NewReqTreatmentNotesMessage>
                      {`Treatment notes ${
                        requisitionForm.collectionDate ? "were" : "will be"
                      } generated and submitted to BillionToOne${
                        requisitionForm.collectionDate
                          ? ""
                          : ", and a local copy will be downloaded for your records"
                      }.`}
                    </NewReqTreatmentNotesMessage>
                  )}
                  <TextField
                    inputRef={notesFieldReference}
                    value={requisitionForm.treatmentNotes}
                    onChange={(e) => {
                      setNewRequisition({
                        ...newRequisition,
                        requisitionForm: {
                          ...newRequisition.requisitionForm,
                          treatmentNotes: e.target.value,
                        },
                      });
                    }}
                    label=""
                    multiline
                    disabled={!requisitionForm.editTreatmentNotes}
                    fullWidth
                    placeholder="Please do not leave this field blank - it is very important for reimbursement"
                  />
                  <UserReportGenerateNotesModalNPIMessage>
                    {`Signed and submitted by ordering provider: ${requisitionForm.orderingHealthcareProviderFormatted}`}
                  </UserReportGenerateNotesModalNPIMessage>
                  {!newRequisition.preflight && (
                    <Button
                      label={getEditButtonText(
                        physicalDeviceType === "mobile",
                        requisitionForm.editTreatmentNotes,
                      )}
                      onClick={() => {
                        if (requisitionForm.editTreatmentNotes) {
                          setNewRequisition({
                            ...newRequisition,
                            requisitionForm: {
                              ...newRequisition.requisitionForm,
                              treatmentNotes:
                                getNewReqTreatmentScreenNotes(requisitionForm),
                              editTreatmentNotes:
                                !requisitionForm.editTreatmentNotes,
                            },
                          });
                        } else {
                          setNewRequisition({
                            ...newRequisition,
                            requisitionForm: {
                              ...newRequisition.requisitionForm,
                              editTreatmentNotes:
                                !requisitionForm.editTreatmentNotes,
                            },
                          });
                        }
                      }}
                      size="small"
                      backgroundColor="white"
                      textColor="greyDark"
                      borderColor="greyDark"
                    />
                  )}
                </NewReqBillingRadioTreatmentNotesWrapper>
              ),
              key: "treatmentNotesAccordion",
            },
          ]}
        />
      </NewReqBillingRadioTreatmentNotesAccordionWrapper>
    </>
  );
};
export default NewReqBillTreatmentNotes;
